import pluralize from 'pluralize';

import { BaseEntity, Transform } from "./base";
import { ServiceType } from "./service-type";

/** Null is untagged, which bills the vehicle's owner. */
export enum Payer {
  Owner = 'owner',
  Recipient = 'recipient',
}

export class Service extends BaseEntity{
  name: string;
  //title: string;

  @Transform(parseFloat)
  price: number;
  description: string;
  enabled: boolean;
  priority: number;
  shortDescription: string;
  stopDuration: number;

  billTo: Nullable<Payer>;
  feesBillTo: Nullable<Payer>;

  static durationString(durationInMinutes: number) {
    const hours = Math.floor(durationInMinutes / 60);
    const minutes = durationInMinutes % 60;
    const hourString = hours ? `${hours} ${pluralize('hour', hours)}` : '';
    const minuteString = minutes ? `${minutes} ${pluralize('minute', hours)}` : '';
    return `${hourString} ${minuteString}`.trim();
  }

  matchesSearch(keywords: string[]): boolean {
    const fullTitle = `${this.name} ${this.title}`.toLowerCase();
    return keywords.every((word) => fullTitle.includes(word.toLowerCase()));
  }

  get durationString() {
    return Service.durationString(this.stopDuration);
  }

  get billsRecipient(): boolean {
    return this.billTo === Payer.Recipient;
  }

  get recipientLiableForFees(): boolean {
    return this.feesBillTo === Payer.Recipient;
  }

  /** Duplicated from the server's reminder templates. Change both together. */
  static readonly LATE_CANCELLATION_FEE_RATE = 0.5;
  static readonly NO_SHOW_FEE_RATE = 1;

  get lateCancellationFee(): number {
    return this.price * Service.LATE_CANCELLATION_FEE_RATE;
  }

  get noShowFee(): number {
    return this.price * Service.NO_SHOW_FEE_RATE;
  }

  get serviceType(): ServiceType {
    return new ServiceType({name: "inspection"})
  }

  get title() {
    return this.name;
  }
}
